<template>
  <div>
    <v-simple-table fixed-header id="style-2" class="task-table-lite" :height="height">
      <template v-slot:default>
        <thead>
          <tr>
            <th></th>
            <th style="min-width: 120px; max-width: 120px">Loại công việc</th>
            <th style="min-width: 150px; max-width: 150px" v-if="type === 'blended'">Chương trình/Khóa học</th>
            <th style="min-width: 170px; max-width: 170px">Nội dung</th>
            <th style="min-width: 150px; max-width: 150px">
              <div class="d-flex align-center">
                Lịch hẹn
                <v-tooltip
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <img
                      @click="handleSortTimeAppointment"
                      v-on="on"
                      v-bind="attrs"
                      src="../trigger_task/assets/img/sort-icon.svg"
                      alt=""
                      class="ml-2"
                      style="cursor: pointer"
                    >
                  </template>
                  <span>{{apointmentSortStatus}}</span>
                </v-tooltip>
              </div>
            </th>
            <th style="min-width: 150px; max-width: 150px">Trạng thái</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="innerTasks.length > 0">
            <tr v-for="(item, index) in innerTasks" :key="index + item">
              <td>
                <v-icon
                  :color="item.status === 2 ? '#94C216' : '#A6A6A6'"
                  :style="item.status !== 2 ? 'cursor: pointer': ''"
                  @click="handleUpdateTask(item)"
                >
                  mdi-check-circle-outline
                </v-icon>
              </td>
              <td>
                <div
                  v-if="LIST_TYPE.find((e) => e.id === item.type)"
                  class="task-type"
                  :class="`${item.type === TASK_TYPE.EXTEND ? 'extend' : 'periodically-care'}`">
                  {{LIST_TYPE.find((e) => e.id === item.type).text}}
                </div>
              </td>
              <td v-if="type=== 'blended'">
                <span v-if="item.curriculum && item.curriculum.id !== 0">
                  {{item.curriculum.title}}
                </span>
                <span v-else>
                  {{item.course ? item.course.name : ''}}
                </span>
              </td>
              <td>
                <v-tooltip
                  top
                  v-if="item.content"
                >
                  <template v-slot:activator="{on, attrs}">
                    <span
                      v-on="on"
                      v-bind="attrs"
                      @click="handleViewTaskDetail(item)"
                      style="cursor: pointer"
                    >
                      {{handleCutContent(item.content)}}
                    </span>
                  </template>
                  <span>Mở xem chi tiết công việc</span>
                </v-tooltip>
              </td>
              <td>
                <div :style="checkDateIsExpire(item) ? 'color : red' : ''">
                  {{formatDateCus(item.appointment_schedule, 'DD/MM/YYYY HH:mm')}}
                </div>
              <td>
                <div
                  class="status-box"
                  v-if="item.status && TASK_STATUS[item.status]"
                  :class="`${TASK_STATUS[item.status].class}`"
                >
                  {{TASK_STATUS[item.status].text}}
                </div>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td :colspan="6" class="text-center red--text">
                Không có dữ liệu
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import {
  TASK_STATUS, LIST_TYPE, TASK_TYPE, TASK_STATUS_OPTION,
} from '@/modules/blended/const';
import StudentCareServices from '@/services/StudentCareServices';

export default {
  name: 'ListTaskLite',
  props: {
    type: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: () => 400,
    },
    tasks: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      TASK_STATUS,
      LIST_TYPE,
      TASK_TYPE,
      sortAppointmentSchedule: 'asc',
      innerTasks: [],
    };
  },
  methods: {
    async handleUpdateTask(item) {
      if (item.status !== 2) {
        const result = await StudentCareServices.updateTask(item.id, { status: 2 });
        if (result.message === 'Success') {
          this.$swal({
            icon: 'success',
            showConfirmButton: false,
            toast: true,
            timer: 1000,
            title: 'Cập nhật trạng thái thành công!',
            position: 'top',
          });
          Bus.$emit('reloadListTask');
          Bus.$emit('recountTotalSuccess');
          this.$emit('reloadList');
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Có lỗi xảy ra, vui lòng thử lại !',
          });
        }
      }
    },
    checkDateIsExpire(item) {
      return item.status === TASK_STATUS_OPTION.find((e) => e.text === 'Quá hạn').id;
    },
    handleViewTaskDetail(item) {
      Bus.$emit('openModalTriggerTask', item);
    },
    handleCutContent(content) {
      let result = '';
      if (content.length > 30) {
        result = `${content.substr(0, 30)}...`;
      } else result = content;
      return result;
    },
    async handleSortTimeAppointment() {
      if (this.sortAppointmentSchedule === 'asc') {
        this.sortAppointmentSchedule = 'desc';
      } else {
        this.sortAppointmentSchedule = 'asc';
      }
      this.$emit('sortTimeAppointment', this.sortAppointmentSchedule);
    },
  },
  watch: {
    tasks: {
      handler(val) {
        this.innerTasks = _.cloneDeep(val);
      },
      deep: true,
    },
  },
  computed: {
    apointmentSortStatus() {
      if (this.sortAppointmentSchedule === 'desc') {
        return 'Sắp xếp từ cũ đến mới';
      }
      if (this.sortAppointmentSchedule === 'asc') {
        return 'Sắp xếp từ mới đến cũ';
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
.task-table-lite {
  width: 100%;
  thead {
    tr {
      th {
        background: #EFEFEF !important;
        color: #767575 !important;
        font-size: 13px !important;
      }
    }
  }
}
.task-type {
  font-weight: bold;
  &.extend {
    color: #8A2E7F;
  }
  &.periodically-care {
    color: #E5652A;
  }
}
.status-box {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-weight: bold;
  width: fit-content;
  font-size: 12px;
  padding: 2px 12px;
  &.expire {
    color: #610404;
    background: #FFD3D2;
  }
  &.pending {
    color: #401341;
    background: #F9D7FA;
  }
  &.done {
    color: #1F3835;
    background: #DDFFFB;
  }
}
</style>
